import CautionIconSVG from '@media/svgs/CautionIconSVG'
import { convertCase } from '@utils/miscUtils'
import { GAME_VIEW_STATUS } from '@core/appearance/resolveGameView'

const capitalize = (value) => convertCase({ value, mode: 'CAPITALIZE' })

// Build the copy for each blocking state. Kept data-driven so the same card
// renders both notices with the right dynamic bits (game name, current view,
// supported views) instead of two near-identical components.
const buildNotice = ({ status, gameCode, game, mode }) => {
  if (status === GAME_VIEW_STATUS.MODE_PROHIBITED) {
    const supported = (game?.modes || []).map(capitalize).join(' or ')
    const name = game?.gameName || 'This game'

    return {
      title: 'View not supported',
      message: `${name} can't be played in ${capitalize(mode)} view${
        supported ? ` — it's available in ${supported} view.` : '.'
      }`,
      detailLabel: 'Current view',
      detail: capitalize(mode),
    }
  }

  // GAME_NOT_FOUND (default)
  return {
    title: 'Game unavailable',
    message: gameCode
      ? `We couldn't find a game matching this code. Please check your launch link and relaunch.`
      : `No game was specified in the launch link. Please relaunch the game to try again.`,
    detailLabel: gameCode ? 'Requested game' : null,
    detail: gameCode || null,
  }
}

/**
 * Full-screen notice card for launch states that block the game from rendering
 * (unknown game code, or a game opened in an unsupported view). Styled from the
 * theme-independent app-default tokens so it looks right even before — or
 * without — a game theme being applied.
 */
const GameNoticeOverlay = ({ status, gameCode, game, mode }) => {
  const { title, message, detailLabel, detail } = buildNotice({ status, gameCode, game, mode })

  return (
    <div className="game-notice-outer-container">
      <div className="game-notice-card">
        <div className="game-notice-header">
          <div className="game-notice-icon-shell">
            <CautionIconSVG color="var(--default-accent-color)" size="24px" />
          </div>
          <div className="game-notice-title">{title}</div>
        </div>

        <div className="game-notice-divider" />

        <div className="game-notice-body">
          <div className="game-notice-message">{message}</div>
          {detail && (
            <div className="game-notice-detail">
              {detailLabel && <span className="game-notice-detail-label">{detailLabel}</span>}
              <span className="game-notice-chip">{detail}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default GameNoticeOverlay
